import { render, staticRenderFns } from "./editmenu.vue?vue&type=template&id=f28b80f6&"
import script from "./editmenu.vue?vue&type=script&lang=ts&"
export * from "./editmenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "editmenu.vue"
export default component.exports